
import { Vue, Component } from 'vue-property-decorator'
import { apiMailGet, apiMailSet, apiMailTest } from '@/api/setting'

@Component({})
export default class SettingMail extends Vue {
    /** S Data **/
    form: any = {
      smtp_open: 0, // 发送开关
      smtp_host: '', // SMTP服务器
      smtp_port: 465, // 端口
      smtp_encryption: 'ssl', // 加密方式
      smtp_user: '', // 账号
      smtp_pass: '', // 密码/授权码
      smtp_from: '', // 发件人地址
      smtp_from_name: '' // 发件人名称
    }

    testEmail = ''
    loading = false
    testing = false

    rules: object = {
      smtp_host: [{ required: true, message: '请填写 SMTP 服务器', trigger: 'blur' }],
      smtp_port: [{ required: true, message: '请填写端口', trigger: 'blur' }],
      smtp_user: [{ required: true, message: '请填写 SMTP 账号', trigger: 'blur' }],
      smtp_pass: [{ required: true, message: '请填写 SMTP 密码/授权码', trigger: 'blur' }],
      smtp_from: [{ type: 'email', message: '发件人地址格式不正确', trigger: 'blur' }]
    }
    /** E Data **/

    /** S Methods **/
    async getConfig () {
      const data: any = await apiMailGet()
      if (data) {
        this.form.smtp_open = Number(data.smtp_open || 0)
        this.form.smtp_host = data.smtp_host || ''
        this.form.smtp_port = Number(data.smtp_port || 465)
        this.form.smtp_encryption = data.smtp_encryption || 'ssl'
        this.form.smtp_user = data.smtp_user || ''
        this.form.smtp_pass = data.smtp_pass || ''
        this.form.smtp_from = data.smtp_from || ''
        this.form.smtp_from_name = data.smtp_from_name || ''
      }
    }

    onSubmitForm (formName: string) {
      (this.$refs[formName] as any).validate(async (valid: boolean) => {
        if (!valid) {
          return
        }
        this.loading = true
        try {
          await apiMailSet({ ...this.form })
          this.getConfig()
        } finally {
          this.loading = false
        }
      })
    }

    async handleTest () {
      if (!this.testEmail) {
        (this as any).$message.warning('请先填写测试接收邮箱')
        return
      }
      this.testing = true
      try {
        await apiMailTest({ email: this.testEmail })
      } catch (e) {
        // 失败提示已由拦截器统一弹出
      } finally {
        this.testing = false
      }
    }
    /** E Methods **/

    created () {
      this.getConfig()
    }
}
